import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { UserService } from '../services';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
    private readonly userService = inject(UserService);
    private readonly translate = inject(TranslateService);

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const currentLanguage = this.translate?.currentLang;
        return of(currentLanguage).pipe(
            // Fetch profile language if language is not yet set
            switchMap((currentLanguage) => (currentLanguage ? of(currentLanguage) : this.userService.getLanguage())),
            switchMap((language) =>
                next.handle(
                    req.clone(
                        req.url.includes(environment.auth.baseUrl)
                            ? {}
                            : {
                                  headers: req.headers.set('X-Profile-Language', language ?? 'en'),
                              }
                    )
                )
            )
        );
    }
}
